type id = string | number;

const sources = {
  appointmentTypes: (gymId: id) => `/gyms/${gymId}/appointment_types`,
  appointmentType: (gymId: id, typeId: id) => `/gyms/${gymId}/appointment_types/${typeId}`,
  bulkMessages: (gymId: id) => `/gyms/${gymId}/bulk_messages`,
  bulkMessage: (gymId: id, bulkMessageId: id) => `/gyms/${gymId}/bulk_messages/${bulkMessageId}`,
  changelog: (gymId: id) => `/gyms/${gymId}/whats_new`,
  changelogItem: (gymId: id, id: id) => `/gyms/${gymId}/whats_new/${id}`,
  dashboardSwitchV1: (gymId: id) => `/gyms/${gymId}/dashboard/switch_to_v1`,
  dashboardSwitchV2: (gymId: id) => `/gyms/${gymId}/dashboard/switch_to_v2`,
  getDashlets: (gymId: id) => `/gyms/${gymId}/dashlets`,
  getDashlet: (gymId: id, dashletId: id) => `/gyms/${gymId}/dashlets/${dashletId}`,
  deleteDashlet: (gymId: id, dashletId: id) => `/gyms/${gymId}/dashlets/${dashletId}`,
  getDashletTypes: (gymId: id) => `/gyms/${gymId}/dashlets/meta`,
  getDashletsForDashboard: (gymId: id) => `/gyms/${gymId}/dashlets/for_dashboard`,
  dismissV2WaiverReminder: (gymId: id) => `/gyms/${gymId}/dashboard/dismiss_v2_waiver_reminder`,
  dismissV2AutopaymentsReminder: (gymId: id) =>
    `/gyms/${gymId}/dashboard/dismiss_v2_autopayments_reminder`,
  dashboardRevenue: (gymId: id) => `/gyms/${gymId}/dashboard/financials`,
  saveDashlet: (gymId: id) => `/gyms/${gymId}/dashlets`,
  createDashletGoal: (gymId: id) => `/gyms/${gymId}/metric_goals`,
  getInterruptionRequests: (gymId: id) => `/gyms/${gymId}/membership_interruption_requests`,
  editInterruptionRequest: (gymId: id, requestId: id) =>
    `/gyms/${gymId}/membership_interruption_requests/${requestId}`,
  getInterruptionRequest: (gymId: id, requestId: id) =>
    `/gyms/${gymId}/membership_interruption_requests/${requestId}`,
  getMembershipInterruptionRequestCount: (gymId: id) =>
    `/gyms/${gymId}/membership_interruption_requests/pending_count`,
  approveCancellationRequest: (gymId: id, requestId: id) =>
    `/gyms/${gymId}/membership_interruption_requests/${requestId}/approve`,
  declineCancellationRequest: (gymId: id, requestId: id) =>
    `/gyms/${gymId}/membership_interruption_requests/${requestId}/reject`,
  editDashletGoal: (gymId: id, goalId: id) => `/gyms/${gymId}/metric_goals/${goalId}`,
  getMembershipPlan: (gymId: id, planId: id) => `/gyms/${gymId}/membership_plans/${planId}`,
  deleteDashletGoal: (gymId: id, goalId: id) => `/gyms/${gymId}/metric_goals/${goalId}`,
  editDashlet: (gymId: id, dashletId: id) => `/gyms/${gymId}/dashlets/${dashletId}`,
  refreshCachedDashletData: (gymId: id) => `/gyms/${gymId}/dashboard/refresh_cache`,
  hideDashlet: (gymId: id, dashletId: id) => `/gyms/${gymId}/dashlets/${dashletId}/hide`,
  refreshDashlet: (gymId: id, dashletId: id) =>
    `/gyms/${gymId}/dashlets/${dashletId}/refresh_cache`,
  getUserDashletOptions: (gymId: id) => `/gyms/${gymId}/dashlets/for_dashlet_select`,
  saveUserDashboardSettings: (gymId: id) => `/gyms/${gymId}/dashboard/update_user_settings`,
  enableDashboardV2GeneralAccess: (gymId: id) =>
    `/gyms/${gymId}/dashboard/enable_v2_general_access`,
  getUserDashboardSettings: (gymId: id) => `/gyms/${gymId}/dashboard/user_settings`,
  getDashboardSettings: (gymId: id) => `/gyms/${gymId}/settings_dashboard.json`,
  eventTypes: (gymId: id) => `/gyms/${gymId}/event_types`,
  productCategories: (gymId: id) => `/gyms/${gymId}/pos/product_categories`,
  sales: (gymId: id) => `/gyms/${gymId}/pos/sales`,
  sale: (gymId: id, saleId: id) => `/gyms/${gymId}/pos/sales/${saleId}`,
  posSettingsItem: (gymId: id, settingId: id) => `/gyms/${gymId}/pos/settings/${settingId}`,
  products: (gymId: id) => `/gyms/${gymId}/pos/products`,
  product: (gymId: id, productId: id) => `/gyms/${gymId}/pos/products/${productId}`,
  taxRates: (gymId: id) => `/gyms/${gymId}/pos/tax_rates`,
  taxRate: (gymId: id, taxRateId: id) => `/gyms/${gymId}/pos/tax_rates/${taxRateId}`,
  reconciliations: (gymId: id) => `/gyms/${gymId}/pos/reconciliations`,
  reconciliation: (gymId: id, dayId: id) => `/gyms/${gymId}/pos/reconciliations/${dayId}`,
  posCustomers: (gymId: id) => `/gyms/${gymId}/pos/customers`,
  privacyPoliciesMeta: (gymId: id) => `/gyms/${gymId}/privacy_policies/meta`,
  membershipPlans: (gymId: id) => `/gyms/${gymId}/membership_plans`,
  archivedMembershipPlans: (gymId: id) => `/gyms/${gymId}/membership_plans/archived_list`,
  membershipPlan: (gymId: id, planId: id) => `/gyms/${gymId}/membership_plans/${planId}`,
  membershipPlanCategories: (gymId: id) => `/gyms/${gymId}/membership_plan_categories`,
  website: (gymId: id) => `/gyms/${gymId}/website`,
  smsDeliveries: (gymId: id) => `/gyms/${gymId}/contact_reports/sms_deliveries`,
  enrolledSequences: (gymId: id) => `/gyms/${gymId}/enrolled_sequences`,
  styles: (gymId: id) => `/gyms/${gymId}/grading/styles`,
  style: (gymId: id, styleId: id) => `/gyms/${gymId}/grading/styles/${styleId}`,
  gradings: (gymId: id) => `/gyms/${gymId}/grading/gradings`,
  gradingEvents: (gymId: id) => `/gyms/${gymId}/grading/grading_events`,
  gradingEvent: (gymId: id, gradingEventId: id) =>
    `/gyms/${gymId}/grading/grading_events/${gradingEventId}`,
  gradingEventAttendees: (gymId: id, gradingEventId: id) =>
    `/gyms/${gymId}/grading/grading_events/${gradingEventId}/attendees`,
  gradingEventAttendee: (gymId: id, gradingEventId: id, attendeeId: id) =>
    `/gyms/${gymId}/grading/grading_events/${gradingEventId}/attendees/${attendeeId}`,
  contactWithType: ({ gymId, contactType, contactId }) =>
    `/gyms/${gymId}/${contactType}/${contactId}`,
  contactMandates: ({ gymId, contactId }) => `/gyms/${gymId}/contacts/${contactId}/mandates`,
  contactMandate: ({ gymId, contactId, mandateId }) =>
    `/gyms/${gymId}/contacts/${contactId}/mandates/${mandateId}`,
  contactMandateSetDefault: ({ gymId, contactId, mandateId }) =>
    `/gyms/${gymId}/contacts/${contactId}/mandates/${mandateId}/set_default`,
  contactCreditVouchers: ({ gymId, contactType, contactId }) =>
    `/gyms/${gymId}/${contactType}/${contactId}/credit_vouchers`,
  contactFamilyCreditVouchers: ({ gymId, contactType, contactId }) =>
    `/gyms/${gymId}/${contactType}/${contactId}/credit_vouchers/family_vouchers`,
  contactSequences: ({ gymId, contactsType, contactId }) =>
    `/gyms/${gymId}/${contactsType}/${contactId}/contact_sequences`,
  contactSequence: ({ gymId, contactsType, contactId, sequenceId }) =>
    `/gyms/${gymId}/${contactsType}/${contactId}/contact_sequences/${sequenceId}`,
  contactNotes: (gymId: id, contactId: id) => `/gyms/${gymId}/contacts/${contactId}/notes`,
  contactDataSeriesRecordings: (gymId: id, contactId: id) =>
    `/gyms/${gymId}/contacts/${contactId}/data_series_recordings`,
  contactDataSeriesResults: (gymId: id, contactId: id) =>
    `/gyms/${gymId}/contacts/${contactId}/data_series_results`,
  dataSeriesMetrics: (gymId: id) => `/gyms/${gymId}/data_series/metrics`,
  contactPaymentMethods: (gymId: id, contactsType: string, contactId: id) =>
    `/gyms/${gymId}/${contactsType}/${contactId}/payment_methods`,
  contactRelationships: (gymId: id, contactId: id) =>
    `/gyms/${gymId}/contacts/${contactId}/contact_relationships`,
  contactNote: (gymId: id, contactId: id, noteId: id) =>
    `/gyms/${gymId}/contacts/${contactId}/notes/${noteId}`,
  contactWaivers: (gymId: id, contactId: id) =>
    `/gyms/${gymId}/contacts/${contactId}/signed_waivers`,
  contactWaiver: (gymId: id, contactId: id, waiverId: id) =>
    `/gyms/${gymId}/contacts/${contactId}/signed_waivers/${waiverId}`,
  contactWorkouts: (gymId: id, contactId: id) => `/gyms/${gymId}/contacts/${contactId}/workouts`,
  contactWorkout: (gymId: id, contactId: id, workoutId: id) =>
    `/gyms/${gymId}/contacts/${contactId}/workouts/${workoutId}`,
  contactInnertelligenceCredentials: ({ gymId, contactType, contactId }) =>
    `/gyms/${gymId}/${contactType}/${contactId}/innertelligence_credentials`,
  contactInnertelligenceCredential: ({ gymId, contactType, contactId, credentialId }) =>
    `/gyms/${gymId}/${contactType}/${contactId}/innertelligence_credentials/${credentialId}`,
  contactBrivoDetails: ({ gymId, contactType, contactId }) =>
    `/gyms/${gymId}/${contactType}/${contactId}/brivo_details`,
  creditVoucherActivities: (gymId: id) => `/gyms/${gymId}/credit_voucher_activities`,
  creditVoucherCategories: (gymId: id) => `/gyms/${gymId}/credit_voucher_categories`,
  sequences: (gymId: id) => `/gyms/${gymId}/sequences/sequences`,
  archivedSequences: (gymId: id) => `/gyms/${gymId}/sequences/sequences/archived_list`,
  sequence: (gymId: id, sequenceId: id) => `/gyms/${gymId}/sequences/sequences/${sequenceId}`,
  sequenceCategories: (gymId: id) => `/gyms/${gymId}/sequences/sequence_categories`,
  sequenceSettings: (gymId: id) => `/gyms/${gymId}/sequences/sequences/update_settings`,
  workouts: (gymId: id) => `/gyms/${gymId}/workouts/workouts`,
  archivedWorkouts: (gymId: id) => `/gyms/${gymId}/workouts/workouts/archived_list`,
  workout: (gymId: id, workoutId: id) => `/gyms/${gymId}/workouts/workouts/${workoutId}`,
  workoutCategories: (gymId: id) => `/gyms/${gymId}/workouts/workout_categories`,
  workoutExercises: (gymId: id) => `/gyms/${gymId}/workouts/exercises`,
  waivers: (gymId: id) => `/gyms/${gymId}/waivers/waivers`,
  archivedWaivers: (gymId: id) => `/gyms/${gymId}/waivers/waivers/archived_list`,
  waiverReviews: (gymId: id) => `/gyms/${gymId}/waivers/reviews`,
  waiver: (gymId: id, waiverId: id) => `/gyms/${gymId}/waivers/waivers/${waiverId}`,
  signedWaivers: (gymId: id) => `/gyms/${gymId}/waivers/signed_waivers`,
  signedWaiver: (gymId: id, waiverId: id) => `/gyms/${gymId}/waivers/signed_waivers/${waiverId}`,
  waiverSignedWaivers: (gymId: id, waiverId: id) =>
    `/gyms/${gymId}/waivers/waivers/${waiverId}/signed_waivers`,
  tasks: (gymId: id) => `/gyms/${gymId}/tasks`,
  tasksMeta: (gymId: id) => `/gyms/${gymId}/tasks/meta`,
  task: (gymId: id, taskId: id) => `/gyms/${gymId}/tasks/${taskId}`,
  taskTypes: (gymId: id) => `/gyms/${gymId}/task_types`,
  contacts: (gymId: id) => `/gyms/${gymId}/contacts`,
  contact: (gymId: id, contactId: id) => `/gyms/${gymId}/contacts/${contactId}`,
  sendContactCommunication: (gymId: id, contactId: id) =>
    `/gyms/${gymId}/contacts/${contactId}/communicate`,
  getContactCommsRecipients: (gymId: id) => `/gyms/${gymId}/contact_comms_recipients`,
  getReplyEmailAddresses: (gymId: id) => `/gyms/${gymId}/reply_email_addresses`,
  sendTestEmail: (gymId: id) => `/gyms/${gymId}/test_comms/send_email`,
  getPushNotificationRouteNames: (gymId: id) =>
    `/gyms/${gymId}/templates/push_notification_route_names`,
  combinedEvents: (gymId: id) => `/gyms/${gymId}/combined_events`,
  locations: (gymId: id) => `/gyms/${gymId}/classrooms`,
  invoices: (gymId: id) => `/gyms/${gymId}/invoices`,
  invoicePlanRealignmentMeta: ({ gymId, contactId, membershipId, contactType }) =>
    `/gyms/${gymId}/${contactType}/${contactId}/memberships/${membershipId}/invoice_plan_realignment_meta`,
  payRates: (gymId: id, userId: id) => ` /gyms/${gymId}/users/${userId}/pay_rates`,
  stripePayers: (gymId: id) => `/gyms/${gymId}/stripe_payers`,
  forms: (gymId: id) => `/gyms/${gymId}/forms`,
  formsWithContactType: (gymId: id, contactType: string) =>
    `/gyms/${gymId}/forms?contact_type=${contactType}`,
  lastCommsActivity: (gymId: id, contactType: string, sourceContactId: id, targetContactId: id) =>
    `/gyms/${gymId}/${contactType}/last_comms_activity?source_contact_id=${sourceContactId}&target_contact_id=${targetContactId}`,
  allForms: (gymId: id) => `/gyms/${gymId}/forms/all_forms`,
  prospectForms: (gymId: id) => `/gyms/${gymId}/forms/prospect_forms`,
  memberForms: (gymId: id) => `/gyms/${gymId}/forms/member_forms`,
  nacForms: (gymId: id) => `/gyms/${gymId}/forms/non_attending_contact_forms`,
  reports: (gymId: id) => `/gyms/${gymId}/reports`,
  report: (gymId: id, reportId) => `/gyms/${gymId}/reports/${reportId}`,
  templates: (gymId: id) => `/gyms/${gymId}/templates`,
  template: (gymId: id, templateId: id) => `/gyms/${gymId}/templates/${templateId}`,
  templateCategories: (gymId: id) => `/gyms/${gymId}/communication_template_categories`,
  sentMessages: (gymId: id) => `/gyms/${gymId}/sent_messages`,
  smsReplies: (gymId: id) => `/gyms/${gymId}/sms_replies`,
  getPosDeliveries: (gymId: id) => `/gyms/${gymId}/pos/deliveries`,
  event: (gymId: id, eventId: id) => `/gyms/${gymId}/calendar/events/${eventId}`,
  eventBookings: (gymId: id, eventId: id) => `/gyms/${gymId}/calendar/events/${eventId}/bookings`,
  eventCancellationReasons: (gymId: id) => `/gyms/${gymId}/event_cancellation_reasons`,
  eventCancellationReason: (gymId: id, reasonId: id) =>
    `/gyms/${gymId}/event_cancellation_reasons/${reasonId}`,
  eventCancellations: (gymId: id) => `/gyms/${gymId}/calendar/event_cancellations`,
  newEventCancellation: (gymId: id) => `/gyms/${gymId}/calendar/event_cancellations/new`,
  eventCancellation: (gymId: id, cancellationId: id) =>
    `/gyms/${gymId}/calendar/event_cancellations/${cancellationId}`,
  createRecurringBookings: (gymId: id, eventId: id) =>
    `/gyms/${gymId}/calendar/events/${eventId}/recurring_bookings`,
  recurringBookings: (gymId: id) => `/gyms/${gymId}/calendar/recurring_bookings`,
  recurringBooking: (gymId: id, recurringBookingId: id) =>
    `/gyms/${gymId}/calendar/recurring_bookings/${recurringBookingId}`,
  recurringBookingEvents: (gymId: id) => `/gyms/${gymId}/calendar/recurring_booking_events`,
  recurringBookingSummaries: (gymId: id) => `/gyms/${gymId}/recurring_booking_summaries`,
  contactNotesReport: (gymId: id) => `/gyms/${gymId}/contact_reports/notes`,
  contactNotesTags: (gymId: id) => `/gyms/${gymId}/tags/notes_detailed`,
  incomeCategories: (gymId: id) => `/gyms/${gymId}/accounting_codes`,
  incomeCategory: (gymId: id, categoryid: id) => `/gyms/${gymId}/accounting_codes/${categoryid}`,
  contactFlagsReport: (gymId: id) => `/gyms/${gymId}/contact_reports/flags`,
  pendingCancellationsReport: (gymId: id) => `/gyms/${gymId}/contact_reports/pending_cancellations`,
  forBulkMobileAppChanges: (gymId: id) => `/gyms/${gymId}/contacts/for_bulk_mobile_app_changes`,
  getPosDeliveryStatuses: (gymId: id) => `/gyms/${gymId}/pos/sale_delivery_statuses`,
  getPosSaleDeliveryStatuses: (gymId: id, saleId) =>
    `/gyms/${gymId}/pos/sales/${saleId}/sale_delivery_status_changes`,
  updatePosSaleDeliveryStatus: (gymId: id, saleId: id) => `/gyms/${gymId}/pos/deliveries/${saleId}`,
  createPosDeliveryStatus: (gymId: id) => `/gyms/${gymId}/pos/sale_delivery_statuses`,
  loadPushNotificationRecipientInfo: (gymId: id) =>
    `/gyms/${gymId}/mobile_app/push_notification_recipients/list`,
  editPosDeliveryStatus: (gymId: id, statusId: id) =>
    `/gyms/${gymId}/pos/sale_delivery_statuses/${statusId}`,
  deletePosDeliveryStatus: (gymId: id, statusId: id) =>
    `/gyms/${gymId}/pos/sale_delivery_statuses/${statusId}`,
  getPosDeliveryStatusHistory: (gymId: id, saleId: id) =>
    `/gyms/${gymId}/pos/sales/${saleId}/sale_delivery_status_changes`,
  mobileAppMeta: (gymId: id) => `/gyms/${gymId}/mobile_app/settings/meta`,
  mobileAppSettings: (gymId: id) => `/gyms/${gymId}/mobile_app/settings`,
  mobileAppSettingsEnablePos: (gymId: id, userId: id) =>
    `/gyms/${gymId}/mobile_app/settings/${userId}/enable_pos_sales`,
  eventDefaults: (gymId: id) => `/gyms/${gymId}/calendar/event_defaults`,
  eventDefault: (gymId: id, eventDefaultId: id) =>
    `/gyms/${gymId}/calendar/event_defaults/${eventDefaultId}`,
  assets: (gymId: id) => `/gyms/${gymId}/assets`,
  asset: (gymId: id, id: id) => `/gyms/${gymId}/assets/${id}`,
  assetUsage: (gymId: id, id: id) => `/gyms/${gymId}/assets/${id}/usage`,
  assetCategories: (gymId: id) => `/gyms/${gymId}/asset_categories`,
  assetCategory: (gymId: id, id: id) => `/gyms/${gymId}/asset_categories/${id}`,
  membership: (gymId: id, membershipId: id) => `/gyms/${gymId}/memberships/${membershipId}`,
  debtors: (gymId: id) => `gyms/${gymId}/debtors`,
  paymentFailuresReport: (gymId: id) => `gyms/${gymId}/payment_failures`,
  mergeCandidates: (gymId: id, sourceContactId: id) =>
    `/gyms/${gymId}/contact_merges/merge_candidates?source_contact_id=${sourceContactId}`,
  contactMergeNew: (gymId: id) => `/gyms/${gymId}/contact_merges/new`,
  contactMerges: (gymId: id) => `/gyms/${gymId}/contact_merges`,
  contactMerge: (gymId: id, contactMergeId: id) => `/gyms/${gymId}/contact_merges/${contactMergeId}`,
  convertNacToMember: () => '/convert_nac_to_member',
  convertNacToProspect: () => '/convert_nac_to_prospect',
  convertProspectToMember: () => '/convert_prospect_to_member',
  convertMemberToProspect: () => '/convert_member_to_prospect',
  convertContactToNac: () => '/convert_contact_to_nac',
  bulkConvertMemberToNac: () => '/bulk_convert_member_to_nac',
  bulkConvertProspectToNac: () => '/bulk_convert_prospect_to_nac',
  bulkConvertNacToMember: () => '/bulk_convert_nac_to_member',
  bulkConvertProspectToMember: () => '/bulk_convert_prospect_to_member',
  bulkConvertNacToProspect: () => '/bulk_convert_nac_to_prospect',
  ownedContactsCount: (gymId: id, contactsType: string, ownerId: id) =>
    `/gyms/${gymId}/${contactsType}/owned_count?owner_id=${ownerId}`,
  deleteUser: (gymId: id, employmentId: id) => `/gyms/${gymId}/users/${employmentId}/destroy_user`,
  membershipCancellations: (gymId: id, contactType: string, contactId: id) =>
    `/gyms/${gymId}/${contactType}/${contactId}/membership_cancellations`,
  membershipCancellation: (gymId: id, contactType: string, contactId: id, cancellationId: id) =>
    `/gyms/${gymId}/${contactType}/${contactId}/membership_cancellations/${cancellationId}`,
  newMembershipCancellation: (gymId: id, contactType: string, contactId: id) =>
    `/gyms/${gymId}/${contactType}/${contactId}/membership_cancellations/new`,
  membershipCancellationReasons: (gymId: id) => `/gyms/${gymId}/membership_cancellation_reasons`,
  monthlyRunRates: (gymId: id) => `gyms/${gymId}/monthly_run_rates`,
  monthlyRunRatesMrrGraph: (gymId: id) => `gyms/${gymId}/monthly_run_rates/mrr_graph`,
  monthlyRunRatesArrGraph: (gymId: id) => `gyms/${gymId}/monthly_run_rates/arr_graph`,
  monthlyRunRatesBreakdown: (gymId: id) => `gyms/${gymId}/monthly_run_rates/breakdown`,
  monthlyRunRatesTable: (gymId: id) => `gyms/${gymId}/monthly_run_rates/table`,
  netRevenue: (gymId: id) => `gyms/${gymId}/net_revenues`,
  netRevenueGraph: (gymId: id) => `gyms/${gymId}/net_revenues/graph`,
  netRevenueBreakdown: (gymId: id) => `gyms/${gymId}/net_revenues/breakdown`,
  netRevenueTable: (gymId: id) => `gyms/${gymId}/net_revenues/table`,
  bulkDeleteMakeupClassesForDeletion: (gymId: id) =>
    `/gyms/${gymId}/bulk_delete_makeup_class_allowances/makeup_classes_for_bulk_deletion`,
  bulkDeleteMakeupClasses: (gymId: id) => `/gyms/${gymId}/bulk_delete_makeup_class_allowances`,
  cwxApiDetails: (gymId: id) => `gyms/${gymId}/api_details`,
  accessControlSettings: (gymId: id) => `gyms/${gymId}/access_control/settings`,
  accessControlOptIn: (gymId: id) => `gyms/${gymId}/access_control/settings/opt_in`,
  accessControlInnertelligenceOptIn: (gymId: id) => `gyms/${gymId}/access_control/settings/innertelligence_opt_in`,
  accessControlUpdateDoorguardCredentials: (gymId: id) => `gyms/${gymId}/access_control/settings/update_doorguard_credentials`,
  stripeBillingPortals: (gymId: id) => `/gyms/${gymId}/stripe_billing_portals`,
  subscription: (gymId: id) => `/gyms/${gymId}/subscription/subscriptions`,
  subscriptionAddon: (gymId: id, priceId: string) =>
    `/gyms/${gymId}/subscription/addons/${priceId}`,
  subscriptionAddons: (gymId: id) => `/gyms/${gymId}/subscription/addons`,
  subscriptionCancelPendingMobileApp: (gymId: id) =>
    `/gyms/${gymId}/subscription/subscriptions/cancel_pending_mobile_app_purchase`,
  subscriptionBilling: (gymId: id) => `/gyms/${gymId}/subscription/billings`,
  subscriptionChange: (gymId: id) => `/gyms/${gymId}/subscription/subscriptions/change_plan`,
  subscriptionDowngradeToFree: (gymId: id) => `/gyms/${gymId}/subscription/subscriptions/downgrade_to_free`,
  subscriptionInvoices: (gymId: id) => `/gyms/${gymId}/subscription/invoices`,
  subscriptionPlans: (gymId: id) => `/gyms/${gymId}/subscription/plans`,
  subscriptionPlansValidate: (gymId: id, planId: string) =>
    `/gyms/${gymId}/subscription/subscriptions/${planId}/validate_change`,
};

export default sources;
